import { useNavigate, useOutletContext, useParams, useSearchParams } from 'react-router-dom';

import Table from '../../ui/Table';
import rightArrowSub from '../../assets/rightSubArrow.svg';
import leftArrowSub from '../../assets/leftSubArrow.svg';
import React, { useEffect, useState } from 'react';
import { getBounty, getBountySubmission, getBountySubmissions, remarkSubmission } from '../../apis/bounties/bounties';
import Input from '../../ui/Input';
import ButtonNew from '../../ui/ButtonNew';
import RadioButtonComponent from '../../ui/RadioButtonComponent';
import { useForm } from 'react-hook-form';
import { dmyFormat } from '../../helpers/dateInDayMonthYearFormat';
import Loader from '../../ui/Loader';
import NoDataAvailable from '../../ui/NoDataAvailable';
import { microtaskTypeData } from '../bounties/microtasktypes/microtaskTypeData';
import { useLoadingState } from '../../hooks/useLoader';
import useLocalStorage from '../../hooks/useLocalStoarge';
import { formatIntDateAndThenTime } from '../../helpers/formatInDateAndThenTime';
import Heading from '../../ui/Heading';
import { toNormalRepresentation } from '../../helpers/convertIntoDecimals';
import { validatingSingleSubmission } from '../../apis/validator/validating';
import AvatarImage from '../../ui/AvatarImage';
import arrowUpward from '../../assets/icons/arrowUpward.svg';
import arrowDownward from '../../assets/icons/arrowDownward.svg';

function BountySubmission() {
    const [submission, setSubmission] = useState({});
    const [submissions, setSubmissions] = useState([]);
    const { loading, startLoading, stopLoading } = useLoadingState();
    const [isRemarking, setIsRemarking] = useState(false);
    const [bountyDetails, setBountyDetails] = useState({});
    const [showAllRanks, setShowAllRanks] = useState(false);
    const [searchParams] = useSearchParams();
    const { bountyId, id, submissionId } = useParams();
    const navigate = useNavigate();

    const {
        register,
        handleSubmit,
        watch,
        reset,
        formState: { errors },
    } = useForm();
    const [isIssueImpact, setIsIssueImpact] = useState('Yes');
    const [isImpactCertificateDisabled, setIsImpactCertificateDisabled] = useState(false);

    // Watch accuracy field for changes
    const accuracyValue = watch('accuracy');

    // Effect to handle accuracy score vs pass threshold logic
    useEffect(() => {
        if (bountyDetails?.passThreshold && accuracyValue !== undefined && accuracyValue !== '') {
            const passThresholdPercentage = bountyDetails.passThreshold * 100;
            const currentAccuracy = Number(accuracyValue);

            if (currentAccuracy < passThresholdPercentage) {
                // Score is below threshold - disable and set to No
                setIsIssueImpact('No');
                setIsImpactCertificateDisabled(true);
            } else {
                // Score meets or exceeds threshold - enable and set to Yes
                setIsIssueImpact('Yes');
                setIsImpactCertificateDisabled(false);
            }
        }
    }, [accuracyValue, bountyDetails?.passThreshold]);

    const changeSubmission = (newId) => {
        navigate(`/organizations/${id}/validation/bounty-submissions/${bountyId}/${newId}`, { replace: true });
    };
    useEffect(
        function () {
            const fetchData = async () => {
                try {
                    const [response1] = await Promise.all([getBountySubmissions(bountyId)]);

                    // setIsLoading(false);
                    setSubmissions(response1);
                } catch (error) {
                    console.log(error);
                }
            };
            fetchData();
        },
        [bountyId]
    );

    useEffect(
        function () {
            console.log('does it run again 2 ?', 'bugs');
            const fetchData = async () => {
                try {
                    startLoading();

                    const [response1, response2] = await Promise.all([
                        getBountySubmission(submissionId),
                        getBounty(bountyId),
                    ]);

                    // const data = await getBountySubmission(submissionId);

                    const resetData = response1?.remark
                        ? {
                            feedback: response1?.remark,
                            accuracy: toNormalRepresentation(response1?.accuracy * 100),
                        }
                        : {
                            feedback: '',
                            accuracy: '',
                        };

                    reset(resetData);

                    if (response1?.remark) {
                        if (response1?.impactCertificateIssued || response1?.issueImpactCertificate)
                            setIsIssueImpact('Yes');
                        else setIsIssueImpact('No');
                    }

                    setSubmission(response1);
                    setBountyDetails(response2);
                } catch (error) {
                    console.log(error);
                } finally {
                    stopLoading();
                }
            };
            fetchData();
        },
        [submissionId]
    );

    const foundSubmissionIndex =
        submissions?.length > 0 ? submissions?.findIndex((s) => s?.submissionId === submissionId) : 0;

    const onSubmit = async (data) => {
        const submissionFetched =
            submissions[foundSubmissionIndex === submissions.length - 1 ? 0 : foundSubmissionIndex + 1];
        const payload = {
            remark: data.feedback,
            accuracy: Number(data.accuracy) / 100,
            ...(bountyDetails.hasImpactCertificate && {
                issueImpactCertificate: isIssueImpact === 'Yes' ? true : false,
            }),
            lastUpdateTime: submission.updatedAt,
        };
        setIsRemarking(true);

        if (bountyDetails?.validationType === 'AFTER_EACH_SUBMISSION') {
            const payloadEach = {
                remark: data.feedback,
                accuracy: Number(data.accuracy) / 100,
                ...(bountyDetails.hasImpactCertificate && {
                    issueImpactCertificate: isIssueImpact === 'Yes' ? true : false,
                }),
                tokenRewarded: false,
            };
            const response = await validatingSingleSubmission(submission.submissionId, payloadEach);

            setIsRemarking(false);
            changeSubmission(submissionFetched?.submissionId);
            return;
        }
        setIsRemarking(true);
        const response = await remarkSubmission(submission.submissionId, payload);

        setIsRemarking(false);

        changeSubmission(submissionFetched?.submissionId);
    };

    const isGradable =
        bountyDetails?.validationType === 'AFTER_EACH_SUBMISSION'
            ? !submission.accuracy
            : bountyDetails?.status !== 'Completed';

    console.log(bountyDetails, 'see the bounty detail here for INR');
    return (
        <div>
            <div className="my-6">
                <p>Bounty Title :</p>

                <Heading type={'large'} className={'text-textPrimary font-medium '}>
                    {bountyDetails?.title ?? '-'}
                </Heading>
            </div>
            <div className="flex  items-center justify-between">
                <div>
                    <p className="text-xs font-medium ">Project Name</p>
                    <p className="font-medium text-textPrimary">{bountyDetails?.project?.title ?? '-'}</p>
                    {submissions?.length > 1 && (
                        <div className="flex items-center gap-3">
                            <img
                                onClick={() => {
                                    const submissionFetched =
                                        submissions[
                                        foundSubmissionIndex === 0
                                            ? submissions?.length - 1
                                            : foundSubmissionIndex - 1
                                        ];

                                    changeSubmission(submissionFetched?.submissionId);
                                }}
                                src={leftArrowSub}
                                alt="Consume"
                                className="w-2 h-2 cursor-pointer"
                            />
                            <span className="font-medium">
                                {foundSubmissionIndex + 1} of {submissions?.length}
                            </span>
                            <img
                                onClick={() => {
                                    const submissionFetched =
                                        submissions[
                                        foundSubmissionIndex === submissions.length - 1
                                            ? 0
                                            : foundSubmissionIndex + 1
                                        ];

                                    changeSubmission(submissionFetched?.submissionId);
                                }}
                                src={rightArrowSub}
                                alt="Consume"
                                className="w-2 h-2 cursor-pointer"
                            />
                        </div>
                    )}
                </div>
                <div className="flex items-center gap-10">
                    <div>
                        <p className="text-xs font-medium ">Acceptance Date</p>
                        <p className="font-medium text-textPrimary">
                            {submission?.acceptanceTimestamp
                                ? formatIntDateAndThenTime(submission?.acceptanceTimestamp)
                                : '-'}
                        </p>
                    </div>
                    <div>
                        <p className="text-xs font-medium ">Submission Date</p>
                        <p className="font-medium text-textPrimary">
                            {submission?.completionTimestamp
                                ? formatIntDateAndThenTime(submission?.completionTimestamp)
                                : '-'}
                        </p>
                    </div>
                </div>
            </div>
            <div className="grid grid-cols-layoutBountySubmission gap-8 ">
                <Table className="  gap-4  " cols="grid-cols-3 ">
                    <Table.Header>
                        <p className="text-sm   font-semibold text-secondaryText flex items-center gap-1  ">
                            Data Points
                        </p>
                        <p className="text-sm  justify-self-center font-semibold text-secondaryText flex items-center gap-1  ">
                            Response Type
                        </p>
                        <p className="text-sm   font-semibold text-secondaryText flex items-center gap-1  "> Content</p>
                    </Table.Header>

                    {loading ? (
                        <div className="min-h-[20vh] flex justify-center items-center">
                            <Loader />
                        </div>
                    ) : Object.keys(submission).length > 0 ? (
                        <div>
                            {submission.data.map((taskSubmission, i) => {
                                const x = microtaskTypeData?.find((obj) => obj?.type === taskSubmission.actionType);
                                return (
                                    <React.Fragment key={x?.type + i}>
                                        {!x ? (
                                            <p>no submission for this task available</p>
                                        ) : (
                                            x.getSubmissionDataComponent({ ...taskSubmission, bountyTitle: bountyDetails?.title })
                                        )}
                                    </React.Fragment>
                                );
                            })}
                        </div>
                    ) : (
                        <NoDataAvailable />
                    )}
                </Table>

                <form onSubmit={handleSubmit(onSubmit)} className="py-6  ">
                    <div className="bg-neutral50C px-8 py-7 rounded-lg ">
                        <div className="mb-6 flex items-center gap-3 justify-between">
                            <div className="w-[50%]">
                                <p className="text-xs">Submission ID</p>
                                <p className="font-medium text-textPrimary truncate">{submissionId}</p>
                            </div>
                            <div className="w-[50%]">
                                <p className="text-xs">Username</p>
                                <div className="flex items-center gap-1 ">
                                    <AvatarImage w="w-6" h="h-6" url={submission?.submitterProfileImage} />
                                    <p className="text-textPrimary  ">{submission?.submitterUsername}</p>
                                </div>
                            </div>
                        </div>

                        {/* Bounty Details Preview Section */}
                        <div className="mt-6  ">
                            <div className="flex items-center justify-between gap-3  mb-4">
                                {/* Number of Winners */}
                                <div className='w-[50%]'>
                                    <p className="text-xs mb-1">Number of winners</p>
                                    <p className="text-base font-medium text-textPrimary">
                                        {bountyDetails?.rewardToken?.distribution?.length || 0}
                                    </p>
                                </div>

                                {/* Reward Token */}
                                <div className='w-[50%]'>

                                    <p className="text-xs  mb-1">{
                                        bountyDetails?.rewardToken?.fiatCurrencyId ? "Reward" : "Reward Token"
                                    }</p>
                                    <div className="flex items-center gap-2">
                                        {
                                            !bountyDetails?.rewardToken?.fiatCurrencyId && <div className="relative">
                                                <img
                                                    className="w-5 h-5 rounded-full"
                                                    src={bountyDetails?.tokenInfo?.image}
                                                    alt={bountyDetails?.tokenInfo?.name}
                                                />
                                                <img
                                                    className="w-[.6rem] h-[.6rem] absolute -top-0.5 -right-0.5 rounded-full border border-white"
                                                    src={bountyDetails?.tokenInfo?.chainImage}
                                                    alt="chain"
                                                />
                                            </div>
                                        }

                                        <div className='flex items-center gap-2'>
                                            <p className="text-textSecondary text-sm uppercase">
                                                {bountyDetails?.rewardToken?.fiatCurrencyId ? bountyDetails?.fiatCurrency?.symbol : bountyDetails?.tokenInfo?.symbol}
                                            </p>
                                            <p className=" text-textPrimary text-base">
                                                {toNormalRepresentation(bountyDetails?.rewardToken?.distribution?.reduce((acc, curr) => acc + curr, 0) || 0)}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Each winner will be awarded */}
                            <div>
                                <p className="text-xs  mb-2">Each winner will be awarded</p>
                                <div className="grid grid-cols-2 gap-2 items-start">
                                    {bountyDetails?.rewardToken?.distribution
                                        ?.slice(0, showAllRanks ? undefined : 4)
                                        ?.map((amount, index) => (
                                            <div key={index} className="flex items-center gap-2 text-sm min-w-0">
                                                <span className="font-medium text-textPrimary">Rank {index + 1}:</span>
                                                <div className="flex items-center gap-1">
                                                    {!bountyDetails?.rewardToken?.fiatCurrencyId && <div className="relative">
                                                        <img
                                                            className="w-5 h-5 rounded-full"
                                                            src={bountyDetails?.tokenInfo?.image}
                                                            alt={bountyDetails?.tokenInfo?.symbol}
                                                        />
                                                        <img
                                                            className="w-[.6rem] h-[.6rem] absolute -top-0.5 -right-0.5 rounded-full"
                                                            src={bountyDetails?.tokenInfo?.chainImage}
                                                            alt="chain"
                                                        />
                                                    </div>}
                                                    <span className="font-medium text-gray-900 whitespace-nowrap text-xs">
                                                        {bountyDetails?.rewardToken?.fiatCurrencyId ? bountyDetails?.fiatCurrency?.symbol : bountyDetails?.tokenInfo?.symbol} {(() => {
                                                            const numValue = Number(toNormalRepresentation(amount));
                                                            if (numValue === 0) return '0';
                                                            if (numValue < 0.01 && numValue > 0) {
                                                                // For very small amounts, use max 4 decimal places to keep it compact
                                                                return numValue.toFixed(4).replace(/\.?0+$/, '');
                                                            }
                                                            // For normal amounts, show up to 2 decimal places
                                                            return numValue.toLocaleString('en-US', {
                                                                minimumFractionDigits: 0,
                                                                maximumFractionDigits: 2
                                                            });
                                                        })()}
                                                    </span>
                                                </div>
                                            </div>
                                        ))}
                                </div>

                                {/* Show More/Less Button */}
                                {bountyDetails?.rewardToken?.distribution?.length > 4 && (
                                    <button
                                        type="button"
                                        onClick={() => setShowAllRanks(!showAllRanks)}
                                        className="text-[#8c8c8c] text-sm font-medium mt-3 transition-colors flex items-center gap-1"
                                    >
                                        {showAllRanks ? (
                                            <>
                                                <span>Show less</span>
                                                <img src={arrowDownward} alt="arrow down" className="w-3 h-3" />
                                            </>
                                        ) : (
                                            <>
                                                <span>Show more</span>
                                                <img src={arrowUpward} alt="arrow up" className="w-3 h-3" />

                                            </>
                                        )}
                                    </button>
                                )}
                            </div>
                        </div>

                        <p className="font-medium text-textPrimary mt-6">Validation Feedback</p>
                        <Input
                            {...register('feedback', {
                                required: 'Please enter your Feedback.',
                            })}
                            className={`w-full mt-2 ${!isGradable ? 'cursor-not-allowed   !bg-disabledColor' : ''}`}
                            type="textArea"
                            disabled={!isGradable}
                            error={errors?.feedback?.message}
                            placeholder="Add Comments"
                        />
                        <div className="mt-6">
                            <p className="font-medium text-textPrimary">Grade the Submission</p>
                            <p className="text-sm">Enter an accuracy score between 1 -100</p>
                            <Input
                                {...register('accuracy', {
                                    required: 'Please enter your Score.',
                                    max: {
                                        value: 100,
                                        message: 'Accuracy score must be less than or equal to 100.'
                                    },

                                })}
                                disabled={!isGradable}
                                className={`w-full mt-2 ${!isGradable ? 'cursor-not-allowed   !bg-disabledColor' : ''
                                    } `}
                                type="number"
                                error={errors?.accuracy?.message}
                                placeholder="0.0"
                            />
                            <p className="text-xs mt-1">
                                Pass threshold set for this bounty is {bountyDetails?.passThreshold * 100}%.
                            </p>
                        </div>
                        {bountyDetails?.hasImpactCertificate && (
                            <div className="mt-6">
                                <p className="font-medium text-textPrimary">Issue Impact Certificate</p>
                                <div className="flex gap-9 items-center ">
                                    <RadioButtonComponent
                                        selectedOption={isIssueImpact}
                                        onSelectOption={setIsIssueImpact}
                                        disabled={!isGradable || isImpactCertificateDisabled}
                                        inputClassName={`${!isGradable || isImpactCertificateDisabled ? 'cursor-not-allowed   bg-disabledColor' : ''}`}
                                        options={['Yes', 'No']}
                                    />
                                </div>
                                {isImpactCertificateDisabled && (
                                    <p className="text-xs mt-1 text-red-500">
                                        Impact certificate cannot be issued as accuracy score is below the pass threshold of {bountyDetails?.passThreshold * 100}%.
                                    </p>
                                )}
                            </div>
                        )}
                        {isGradable && (
                            <ButtonNew
                                className="mt-8"
                                variant="blue"
                                size="md"
                                shape="rounded"
                                type="submit"
                            >
                                {isRemarking ? <Loader /> : 'Validate Submission'}
                            </ButtonNew>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
}

export default BountySubmission;
